var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PreloadableMeshProviderBase } from "./PreloadableMeshProviderBase";
import { applyUserWireframeToMeshes } from "../rendering/shader/BarycentricWireframe";
export class ShoulderMeshProvider extends PreloadableMeshProviderBase {
    constructor() {
        super("meshes/shoulders/Shoulders_A_03");
    }
    getShoulderMesh(connection) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = yield this.getMesh(connection);
            // Each avatar can have a different attributes,
            // therefore a new material is needed for each mesh
            applyUserWireframeToMeshes(mesh, true);
            return mesh;
        });
    }
}
